import { motion } from 'motion/react';
import { Button } from './ui/button';
import { Clock } from 'lucide-react';

interface TimeRangeSelectorProps {
  selected: number;
  onChange: (hours: number) => void;
}

const ranges = [
  { label: '6h', hours: 6 },
  { label: '12h', hours: 12 },
  { label: '24h', hours: 24 },
  //{ label: '7d', hours: 168 },
];

export function TimeRangeSelector({ selected, onChange }: TimeRangeSelectorProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="flex items-center gap-2 bg-white rounded-lg p-1 shadow-sm"
    >
      <Clock className="w-4 h-4 text-gray-500 ml-2" />
      <span className="text-sm text-gray-600 mr-1">Zakres:</span>
      {ranges.map((range) => (
        <Button
          key={range.hours}
          variant={selected === range.hours ? 'default' : 'ghost'}
          size="sm"
          onClick={() => onChange(range.hours)}
          className="text-xs"
        >
          {range.label}
        </Button>
      ))}
    </motion.div>
  );
}
